import { InputCheckbox } from '@components/input-checkbox';
import { formatCurrency } from '@utils/price-formatter/price-formatter';
import classNames from 'classnames';

import { AddOnPresetRowProps } from '../add-ons-presets-modal.type';

export const AddOnPresetRow = ({ addon, name, checked, onToggle, disabled, dataTestId }: AddOnPresetRowProps) => {
  const formattedPrice = formatCurrency({
    currency: addon.fixedPrice.currency,
    number: addon.fixedPrice.amount,
  });

  return (
    <div data-testid={dataTestId} className='flex items-center justify-between gap-4 px-3 py-3 rounded-md bg-primary'>
      <div className='flex items-center gap-2 min-w-0'>
        <InputCheckbox value={checked} name={addon.id} onChange={() => onToggle(addon.id)} disabled={disabled} />
        <label
          htmlFor={addon.id}
          className={classNames('truncate min-w-0 cursor-pointer', {
            'text-subtitle-s text-primary': checked,
            'text-body-s text-secondary': !checked,
          })}>
          {name}
        </label>
      </div>
      <span
        className={classNames('shrink-0', {
          'text-subtitle-s text-primary': checked,
          'text-body-s text-secondary': !checked,
        })}>
        {formattedPrice}
      </span>
    </div>
  );
};
